import { defineStore } from 'pinia'
import { ref } from 'vue'
import { setPageLoading } from '@/services/api'

export const useGlobalStore = defineStore('global', () => {
  const isLoading = ref(false)

  function setLoading(status: boolean) {
    isLoading.value = status
    setPageLoading(status)
  }

  return {
    isLoading,
    setLoading
  }
})
